import script from "./PersonalCenterView.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalCenterView.vue?vue&type=script&setup=true&lang=js"

import "./PersonalCenterView.vue?vue&type=style&index=0&id=ea1ad19a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea1ad19a"]])

export default __exports__